<script setup lang="ts">
import { computed } from "vue";

interface PreviewDocumentProps {
  src?: string;
}

const props = withDefaults(defineProps<PreviewDocumentProps>(), {
  src: "",
});

const getDocumentExtension = computed(() => {
  if (props.src) {
    const parts = props.src.split(".");
    return parts.length > 1 ? parts.pop()?.toUpperCase() : "UNKNOWN";
  }
  return "No Document";
});

function onPreviewDocument() {
  const previewElement = document.querySelector(".view-box") as HTMLElement;
  if (previewElement) {
    previewElement.click();
  }
}
</script>

<template>
  <div>
    <slot name="title">
      <div class="document" @click="onPreviewDocument">
        Document ({{ getDocumentExtension }})
      </div>
    </slot>

    <c-img :src="props.src" style="display: none" class="view-box"></c-img>
  </div>
</template>

<style lang="scss">
.document {
  color: var(--primary);
  cursor: pointer;
}
</style>
